// Header 1046 — BDU contact strip (bduedu.in `organisms/ContactBanner`).
// A 42px slate band above the nav: right-aligned phone pill(s) + a WhatsApp
// pill. Below 768px the band gives way to the reference's round phone and
// WhatsApp buttons pinned to the left edge — same data, no extra fields —
// unless `show_on_mobile` puts the band itself back on mobile.
//
// Structurally the same widget as Header 7 — dynamic pill rows in the shared
// `metadata` JSON plus the `whatsapp_*` columns — so it reuses those columns
// verbatim and needs no new ones. Only the `header.variant` ENUM widens.
//
// The pill radii (16px / 14px) and their inset highlight shadows are brand
// chrome baked into the reference, so they live in the widget, not here.

export const HEADER_1046_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Contact pills",
  },

  DEFAULT_ROW: {
    id: "1",
    widget_label: "",
    widget_value: "",
    widget_link: "",
    priority: 1,
    status: true,
  },

  METADATA_FIELDS: [
    {
      header: "Label",
      fieldName: "widget_label",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Phone NO.",
    },
    {
      header: "Value",
      fieldName: "widget_value",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Text shown after the label (e.g. +91-8956667205)",
    },
    {
      header: "Link",
      fieldName: "widget_link",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Optional href (e.g. tel:+918956667205)",
      required: false,
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Sort order (lower first)",
      required: false,
      defaultValue: 1,
    },
    {
      header: "Row status",
      fieldName: "status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Show this pill",
      defaultValue: true,
    },
  ],

  HEADER_FIELDS_CONFIG: [
    {
      fieldName: "background_color",
      label: "Bar background color",
      value: "#354D6C",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "e.g. #354D6C",
      required: false,
      defaultValue: "#354D6C",
    },
    {
      fieldName: "pill_background_color",
      label: "Contact pill background",
      value: "rgba(255, 255, 255, 0.10)",
      valueType: "string",
      filedType: "RGBA",
      placeholder: "e.g. rgba(255,255,255,0.10)",
      required: false,
      defaultValue: "rgba(255, 255, 255, 0.10)",
    },
    {
      fieldName: "label_text_color",
      label: "Pill icon color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "phone_text_color",
      label: "Pill text color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "phone_icon",
      label: "Phone icon (optional)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Overrides the default phone glyph when set",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "phone_icon_alt",
      label: "Phone icon alt",
      value: "Phone",
      valueType: "string",
      filedType: "INPUT",
      required: false,
      defaultValue: "Phone",
    },
    {
      fieldName: "whatsapp_show",
      label: "Show WhatsApp pill",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      required: false,
      defaultValue: true,
    },
    {
      fieldName: "whatsapp_number",
      label: "WhatsApp number",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Digits with country code (e.g. 918956667205)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "whatsapp_link",
      label: "WhatsApp link (optional override)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Leave empty to build from the number above",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "whatsapp_button_text",
      label: "WhatsApp button text",
      value: "WhatsApp Chat",
      valueType: "string",
      filedType: "INPUT",
      required: false,
      defaultValue: "WhatsApp Chat",
    },
    {
      fieldName: "whatsapp_button_color",
      label: "WhatsApp pill background",
      value: "rgba(76, 175, 81, 0.70)",
      valueType: "string",
      filedType: "RGBA",
      placeholder: "e.g. rgba(76,175,81,0.70)",
      required: false,
      defaultValue: "rgba(76, 175, 81, 0.70)",
    },
    {
      fieldName: "whatsapp_button_text_color",
      label: "WhatsApp text / icon color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "whatsapp_icon",
      label: "WhatsApp icon (optional)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Overrides the default WhatsApp glyph when set",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "show_on_mobile",
      label:
        "Show the strip below 768px (default: off — mobile gets the floating phone/WhatsApp buttons instead)",
      value: false,
      valueType: "boolean",
      filedType: "SWITCH",
      required: false,
      defaultValue: false,
    },
    {
      fieldName: "sticky_to_top",
      label: "Stick to top on scroll",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      required: false,
      defaultValue: true,
    },
    {
      fieldName: "status",
      label: "Status",
      value: true,
      valueType: "boolean",
      filedType: "SWITCH",
      placeholder: "Toggle status",
      required: false,
      defaultValue: true,
    },
  ],
};
